import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-login-page',
  standalone: true,
  imports: [FormsModule, NgIf, RouterLink],
  templateUrl: './login.page.html',
  styleUrl: './login.page.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LoginPageComponent {
  email = '';
  password = '';
  errorMessage = '';
  isLoading = false;

  constructor(
    private readonly authService: AuthService,
    private readonly router: Router,
    private readonly cdr: ChangeDetectorRef
  ) {}

  submit(): void {
    if (!this.email || !this.password) {
      this.errorMessage = 'Veuillez saisir vos identifiants.';
      return;
    }
    this.errorMessage = '';
    this.isLoading = true;
    this.authService.login(this.email, this.password).subscribe({
      next: () => {
        this.isLoading = false;
        this.router.navigateByUrl('/home');
        this.cdr.markForCheck();
      },
      error: error => {
        this.isLoading = false;
        if (error?.status === 0 || error?.status >= 500) {
          this.errorMessage = 'Service indisponible. Réessayez dans quelques instants.';
        } else {
          this.errorMessage = 'Identifiants incorrects ou compte inactif.';
        }
        this.cdr.markForCheck();
      }
    });
  }
}
